export default __webpack_public_path__ + "static/media/welcome-bg1.b5be009e.png";